module.exports = ".college-logo {\r\n  border-radius: 50%;\r\n  width: 60px;\r\n  height: 60px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.pull-right > .dropdown-menu {\r\n  right: 0;\r\n  left: 0;\r\n}\r\n\r\n.valign-middle > a {\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.font-s58 {\r\n  font-size: 58px !important;\r\n}\r\n\r\ni.fa.fa-star.start-checked {\r\n  color: orange;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/college-list-grid/college-list-grid.component.css
// module id = ./src/app/shared/components/college-list-grid/college-list-grid.component.css
// module chunks = main